//breadcrumbの移動
document.addEventListener('DOMContentLoaded', function () {
  const breadcrumb = document.querySelector('.breadcrumb');
  const heroSection = document.querySelector('.shopify-section .index-hero');

  if (breadcrumb && heroSection) {
    // heroSection の直後に breadcrumb を移動
    heroSection.insertAdjacentElement('afterend', breadcrumb);
  }
});
//スライダー
window.addEventListener( 'load', function(){
  $(".aw-about-us-concept__item-wrap").slick({
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    infinite: false,
    speed: 500,
    fade: true,
    swipe: false,
    arrows: false,
    variableWidth: false,
    lazyLoad: "progressive",
    asNavFor: ".aw-about-us-concept__nav",
    responsive: [{
      breakpoint: 767,
      settings: {
      }
    }]
  });
  $(".aw-about-us-concept__nav").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    asNavFor: ".aw-about-us-concept__item-wrap",
    focusOnSelect: true,
    arrows: false,
    variableWidth: true,
    responsive: [{
      breakpoint: 767,
      settings: {
      }
    }]
  });

  document.querySelectorAll('.aw-about-us-concept__slider').forEach((section) => {
    const $slider = $(section);

    if (!$slider.hasClass('slick-initialized')) {
      const $slickCount = $(`
        <div class="section-slick-count slick-count">
          <span class="slick-count__current"></span>
          <span class="slick-count__slash"> / </span>
          <span class="slick-count__all"></span>
        </div>
      `);
      $slider.after($slickCount);

      $slider
        .on('init', function (event, slick) {
          $slickCount.find('.slick-count__current').text(slick.currentSlide + 1);
          $slickCount.find('.slick-count__all').text(slick.slideCount);
        })
        .slick({
          autoplay: false,
          slidesToShow: 4,
          slidesToScroll: 1,
          adaptiveHeight: false,
          infinite: true,
          speed: 500,
          fade: false,
          swipe: true,
          swipeToSlide: true,
          arrows: true,
          prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none"><circle cx="26" cy="26" r="26" fill="#0B9B92"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.125 25.75C17.125 25.461 17.2494 25.1838 17.4708 24.9794C17.6922 24.775 17.9925 24.6602 18.3056 24.6602H30.5962L26.3145 20.7078C26.106 20.5012 25.9924 20.2279 25.9978 19.9456C26.0032 19.6633 26.1271 19.3939 26.3435 19.1942C26.5598 18.9945 26.8516 18.8802 27.1574 18.8752C27.4633 18.8702 27.7593 18.975 27.9831 19.1675L34.2797 24.9799C34.5008 25.1842 34.625 25.4612 34.625 25.75C34.625 26.0388 34.5008 26.3158 34.2797 26.5201L27.9831 32.3325C27.7593 32.525 27.4633 32.6298 27.1574 32.6248C26.8516 32.6199 26.5598 32.5055 26.3435 32.3058C26.1271 32.1061 26.0032 31.8367 25.9978 31.5544C25.9924 31.2721 26.106 30.9988 26.3145 30.7922L30.5962 26.8398H18.3056C17.9925 26.8398 17.6922 26.725 17.4708 26.5206C17.2494 26.3162 17.125 26.039 17.125 25.75Z" fill="white"/></svg></button>',
          nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none"><circle cx="26" cy="26" r="26" fill="#0B9B92"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.125 25.75C17.125 25.461 17.2494 25.1838 17.4708 24.9794C17.6922 24.775 17.9925 24.6602 18.3056 24.6602H30.5962L26.3145 20.7078C26.106 20.5012 25.9924 20.2279 25.9978 19.9456C26.0032 19.6633 26.1271 19.3939 26.3435 19.1942C26.5598 18.9945 26.8516 18.8802 27.1574 18.8752C27.4633 18.8702 27.7593 18.975 27.9831 19.1675L34.2797 24.9799C34.5008 25.1842 34.625 25.4612 34.625 25.75C34.625 26.0388 34.5008 26.3158 34.2797 26.5201L27.9831 32.3325C27.7593 32.525 27.4633 32.6298 27.1574 32.6248C26.8516 32.6199 26.5598 32.5055 26.3435 32.3058C26.1271 32.1061 26.0032 31.8367 25.9978 31.5544C25.9924 31.2721 26.106 30.9988 26.3145 30.7922L30.5962 26.8398H18.3056C17.9925 26.8398 17.6922 26.725 17.4708 26.5206C17.2494 26.3162 17.125 26.039 17.125 25.75Z" fill="white"/></svg></button>',
          variableWidth: false,
          lazyLoad: "progressive",
          responsive: [{
            breakpoint: 767,
            settings: {
              variableWidth: true,
              slidesToShow: 1,
              prevArrow: '<button type="button" class="slick-prev">Previous</button>',
              nextArrow: '<button type="button" class="slick-next">Next</button>',
              appendArrows: $slickCount,
            }
          }]
        })
        .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          $slickCount.find('.slick-count__current').text(nextSlide + 1);
        });
    }
  });
});